import {
  GET_EMPLOYEETAX,
  GET_EMPLOYEETAX_SUCCESS,
  GET_EMPLOYEETAX_FAIL,
  DELETE_EMPLOYEETAX,
  DELETE_EMPLOYEETAX_SUCCESS,
  DELETE_EMPLOYEETAX_FAIL,
  UPDATE_EMPLOYEETAX,
  UPDATE_EMPLOYEETAX_SUCCESS,
  UPDATE_EMPLOYEETAX_FAIL,
  ADD_NEW_EMPLOYEETAX,
  ADD_EMPLOYEETAX_SUCCESS,
  ADD_EMPLOYEETAX_FAIL,
  EMPLOYEETAX_LOADING,
  EMPLOYEETAX_RESET,
} from "./actionType";

export const resetEmployeeTaxState = (actionType) => ({
  type: EMPLOYEETAX_RESET,
  payload: { actionType },
});

export const getEmployeeTaxSuccess = (actionType, data) => ({
  type: GET_EMPLOYEETAX_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeTaxFail = (actionType, error) => ({
  type: GET_EMPLOYEETAX_FAIL,
  payload: { actionType, error },
});

export const getEmployeeTax = data => ({
  type: GET_EMPLOYEETAX,
  payload: data,
});

export const getEmployeeTaxLoading = () => ({
  type: EMPLOYEETAX_LOADING
});

export const deleteEmployeeTax = data => ({
  type: DELETE_EMPLOYEETAX,
  payload: data,
});

export const deleteEmployeeTaxSuccess = data => ({
  type: DELETE_EMPLOYEETAX_SUCCESS,
  payload: data,
});

export const deleteEmployeeTaxFail = error => ({
  type: DELETE_EMPLOYEETAX_FAIL,
  payload: error,
});

export const updateEmployeeTax = data => ({
  type: UPDATE_EMPLOYEETAX,
  payload: data,
});

export const updateEmployeeTaxFail = error => ({
  type: UPDATE_EMPLOYEETAX_FAIL,
  payload: error,
});

export const updateEmployeeTaxSuccess = data => ({
  type: UPDATE_EMPLOYEETAX_SUCCESS,
  payload: data,
});

export const addNewEmployeeTax = data => ({
  type: ADD_NEW_EMPLOYEETAX,
  payload: data,
});

export const addEmployeeTaxSuccess = data => ({
  type: ADD_EMPLOYEETAX_SUCCESS,
  payload: data,
});

export const addEmployeeTaxFail = error => ({
  type: ADD_EMPLOYEETAX_FAIL,
  payload: error,
});